import React, { useState } from "react";
import "./style.scss";
import { useLayoutAPI, useLayoutState } from "../../contexts/layout";
import Table from "@/components/Table";
import HeaderColumn from "@/components/Table/table-header/HeaderColumn";
import HeaderColumnSort from "@/components/Table/table-header/HeaderColumnSort";
import HeaderColumnTooltip from "@/components/Table/table-header/HeaderColumnTooltip";
import CheckBox from "@/components/Checkbox";
import BodyColumn from "@/components/Table/table-body/BodyColumn";
import BodyImageWithInfoColumn from "@/components/Table/table-body/BodyImageWithInfoColumn";
import PROFILE_PIC from "@/assets/images/Avatar-3x.png";
import Badge from "@/components/Badge";
import Toogle from "@/components/Toogle";
import Button from "@/components/Button";
import Input from "@/components/Input";
import Pagination from "@/components/Pagination";
import Dropdown from "@/components/Dropdown";
import ID_ICON from "@/assets/icons/ID.svg";
import InputPhoneNumber from "@/components/InputPhoneNumber";
import InputCurrency from "@/components/InputCurrency";
import SelectImage from "@/components/SelectImage";
import InputPass from "@/components/InputPassword";
import TextArea from "@/components/TextArea";
import Modal from "@/components/Modal";
import DatePick from "@/components/DatePicker";

const ComponentShowCase = () => {
  const { sideBarConf } = useLayoutState();
  const { setSidebarConf } = useLayoutAPI();
  const [checked, setChecked] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [sort, setSort] = useState<any>("asc");
  const [input, setInput] = useState<any>("");
  const [date, setDate] = useState<Date | null>(new Date());
  const [activePage, setActivePage] = useState<any>(3);
  const [dropdownVal, setDropdownVal] = useState<any>();
  const [dropdownPhone, setDropdownPhone] = useState<any>({
    imgSrc: ID_ICON,
    countryLabel: "Indonesia",
    countryCode: "ID",
    countryPhoneCode: "+62",
  });
  const [inputVal, setInputVal] = useState<string>("");
  const [inputMoney, setInputMoney] = useState<string>("");

  const handleChange = (e: any) => {
    setInput(e.target.value);
    console.log("isi input : ", input);
  };

  return (
    <div className="component-show-case-wrapper">
      <div className="intro">
        <h1>Component Show Case</h1>
        <span>component playground</span>

        <br />
        <span onClick={() => setSidebarConf({ isShow: !sideBarConf.isShow })}>
          Context <b>(click to change the value)</b>: {`${sideBarConf.isShow}`}
        </span>
      </div>

      {/* put your component after this line */}

      <Table>
        <thead>
          <tr>
            <th className="column-checkbox-wrapper">
              <CheckBox
                checked={checked}
                onChange={() => setChecked(!checked)}
              />
            </th>
            <HeaderColumn label="Toogle" alignLabel="text-right" />
            <HeaderColumn label="Test 1" alignLabel="text-right" />
            <HeaderColumnSort
              label="Test 2"
              sortType={sort}
              onChange={(e) => setSort(e)}
              alignLabel="text-center"
            />
            <HeaderColumnTooltip label="Test 3" toolTipText="asd" />
            <th>Badge</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="column-checkbox-wrapper" width="50px">
              <CheckBox
                checked={checked}
                onChange={() => setChecked(!checked)}
              />
            </td>
            <td width="50px">
              <Toogle checked={checked} onChange={() => setChecked(!checked)} />
            </td>
            <BodyColumn
              width="300px"
              label="Test 123"
              alignLabel="text-right"
            />
            <BodyImageWithInfoColumn
              width="300px"
              imgSrc={PROFILE_PIC}
              roundedImg="20px"
              textName="Name?"
              textDesc="Desc?"
            />
            <BodyColumn
              width="300px"
              label="Test 123"
              alignLabel="text-right"
              color="black"
            />
            <td>
              <Badge
                label="Test"
                labelColor="white"
                backgroundColor="black"
                border="1px solid red"
                dot
                dotColor="white"
              />
            </td>
          </tr>
        </tbody>
      </Table>
      <Pagination
        activePage={activePage}
        totalPage={15}
        onChange={(e) => setActivePage(e)}
      />
      <div style={{ height: 20 }} />
      <InputCurrency
        value={inputMoney}
        onChange={setInputMoney}
        width="400px"
        disabled={false}
      />

      <InputPhoneNumber
        value={dropdownPhone}
        inputValue={inputVal}
        options={[
          {
            imgSrc: ID_ICON,
            countryLabel: "Indonesia",
            countryCode: "ID",
            countryPhoneCode: "+62",
          },
          {
            imgSrc: ID_ICON,
            countryLabel: "Other Indonesia",
            countryCode: "IDS",
            countryPhoneCode: "+65",
          },
        ]}
        onChange={(e) => setDropdownPhone(e)}
        onChangeInputValue={(e) => setInputVal(e)}
        disabled={false}
        width="400px"
      />

      <Dropdown
        placeHolder="Select Option..."
        value={dropdownVal}
        options={[
          { label: "test 1", value: "test_1" },
          { label: "test 2", value: "test_2" },
          { label: "test 3", value: "test_3" },
        ]}
        onChange={(e) => setDropdownVal(e)}
        disabled={false}
        optionType="text-option"
        // width="400px"
      />

      <div style={{ height: 20 }} />

      <SelectImage
        onChange={(e) => console.log("===e: ", e)}
        disabled={true}
        displayIcon={false}
        desc="SVG, PNG, JPG or GIF (max. 1200x1200px)"
      />

      <Dropdown
        placeHolder="Select Option..."
        value={dropdownVal}
        options={[
          {
            label: "test 1",
            value: "test_1",
            imgSrc: PROFILE_PIC,
            desc: "exp desc",
          },
          {
            label: "test 2",
            value: "test_2",
            imgSrc: PROFILE_PIC,
            desc: "exp desc",
          },
        ]}
        onChange={(e) => setDropdownVal(e)}
        disabled={false}
        optionType="product-option"
        width="400px"
      />
      <div style={{ height: 10 }} />
      <Input
        style={{ width: "300px" }}
        withIcon
        type="search"
        value={input}
        onChange={handleChange}
        placeholder="Search"
        withTooltip
        hint="tooltip search"
      />
      <div style={{ height: 10 }} />
      <Input
        style={{ width: "300px" }}
        withIcon
        type="email"
        value={input}
        onChange={handleChange}
        placeholder="your@mail.com"
        withTooltip
        hint="tooltip email"
      />
      <div style={{ height: 10 }} />
      <Input
        style={{ width: "300px" }}
        value={input}
        onChange={handleChange}
        placeholder="Text Input"
      />
      <div style={{ height: 10 }} />
      <InputPass
        style={{ width: "300px" }}
        value={input}
        onChange={handleChange}
      />
      <div style={{ height: 10 }} />
      <Input
        style={{ width: "300px" }}
        disabled
        value={input}
        onChange={handleChange}
        placeholder="Text Input Disabled"
      />
      <div style={{ height: 20 }} />
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          gap: 10,
        }}
      >
        <Button
          onClick={() => console.log("kliiiik!!!!")}
          label="Button okokokok"
          size="md"
          startIcon="save"
        />
        <div style={{ height: 10 }} />
        <Button
          onClick={() => console.log("kliiiik!!!!")}
          label="Button okokokok"
          size="md"
          startIcon="edit"
          disabled
        />

        <div style={{ height: 10 }} />
        <Button
          onClick={() => console.log("kliiiik!!!!")}
          label="Button okokokok"
          type="secondary"
          size="lg"
          startIcon="sync"
        />
        <div style={{ height: 10 }} />
        <Button
          onClick={() => console.log("kliiiik!!!!")}
          label="Button okokokok"
          type="secondary"
          size="lg"
          startIcon="sync"
          disabled
        />
        <div style={{ height: 10 }} />
        <Button
          onClick={() => console.log("kliiiik!!!!")}
          label="Button okokokok"
          type="secondary"
          size="lg"
          disabled
        />
        <div style={{ height: 10 }} />
        <Button
          onClick={() => console.log("kliiiik!!!!")}
          label="Button okokokok"
          type="light"
          size="xl"
          startIcon="setting"
        />
        <div style={{ height: 10 }} />
        <Button
          onClick={() => console.log("kliiiik!!!!")}
          label="Button okokokok"
          type="light"
          size="xl"
          startIcon="plus"
          disabled
        />
        <div style={{ height: 10 }} />
        <Button
          onClick={() => console.log("kliiiik!!!!")}
          label="Prev"
          type="warning"
          size="xxl"
          startIcon="arrowLeft"
        />
        <div style={{ height: 10 }} />
        <Button
          onClick={() => console.log("kliiiik!!!!")}
          label="Next"
          type="warning"
          size="xxl"
          disabled
          endIcon="arrowRight"
        />
      </div>
      <div style={{ height: 10 }} />
      <TextArea
        maxLength={100}
        value={input}
        onChange={handleChange}
        placeholder="Enter a description"
      />
      <div style={{ height: 10 }} />
      <Button
        onClick={() => setShowModal(!showModal)}
        label="SHOW MODAL"
        type="secondary"
        size="lg"
      />
      <div style={{ height: 10 }} />
      <DatePick value={date} onChange={(e) => setDate(e)} />
      <div style={{ height: 50 }} />
      {showModal && (
        <Modal
          header={<div>Header</div>}
          content={<div style={{ height: "100px" }}>Content</div>}
          action={
            <div>
              {" "}
              <Button
                onClick={() => setShowModal(!showModal)}
                label="Close"
                type="warning"
                size="md"
              />
            </div>
          }
          type=""
          setIsOpen={() => setShowModal(!showModal)}
        />
      )}
    </div>
  );
};

export default ComponentShowCase;
